export const getTransitionAssets = ({
  transitions,
  sliderTime,
}) => transitions.filter(tr => (tr.startTime <= sliderTime && tr.endTime >= sliderTime))
